var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-select',{staticClass:"my-0",class:_vm.value === 'new'
        ? 'text-warning'
        : '' || _vm.value === 'onprogress'
        ? 'text-info'
        : '' || _vm.value === 'approved'
        ? 'text-primary'
        : '' || _vm.value === 'rejected'
        ? 'text-danger'
        : '',attrs:{"disabled":_vm.session.role != 'ce' && _vm.session.role != 'superadmin',"value":_vm.value,"id":"input-1"},on:{"change":function($event){return _vm.showConfirmation(_vm.value, $event)}}},[_c('option',{staticClass:"text-warning",attrs:{"value":"new"}},[_vm._v("Baru")]),_c('option',{staticClass:"text-info",attrs:{"value":"onprogress"}},[_vm._v("Diproses")]),_c('option',{staticClass:"text-primary",attrs:{"value":"approved"}},[_vm._v("Diterima")]),_c('option',{staticClass:"text-danger",attrs:{"value":"rejected"}},[_vm._v("Ditolak")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }